// @flow
import React from "react";
import {
    type CardItemResultDTO,
    type CardItemDTO,
    type CardTypeEnum,
    CardItemType,
} from "data/types";
import ArchiveTargetHeader from "components/ArchiveTargets/ArchiveTargetHeader";
import CardList from "components/CardList";
import { type ConstantsEnum } from "data/constants";

type Props = {
    /** callback when user cancels */
    onCancel: () => void,
    /** callback when user clicks a card */
    onClick: (card: CardItemDTO) => void,
    /** current ArchiveTarget */
    archiveTarget: CardItemResultDTO,
    /** current cards loading status */
    status: ConstantsEnum,
    /** list of cards  */
    cards: Array<CardItemDTO>,
    /** filter by CardType */
    cardType: CardTypeEnum,
};

type State = {
    filterText: string,
};

class ArchiveTargetCards extends React.PureComponent<Props, State> {
    state = { filterText: "" };

    _onFilterTextChange = (filterText: ?string) =>
        this.setState({
            filterText: filterText || "",
        });

    _getFilteredCards = () =>
        this.props.cards.filter(
            (c) =>
                this.state.filterText.length === 0 ||
                c.name.toLowerCase().indexOf(this.state.filterText) >= 0
        );

    render() {
        const {
            onCancel,
            onClick,
            archiveTarget,
            status,
            cardType,
        } = this.props;

        return (
            <>
                <ArchiveTargetHeader
                    archiveTarget={archiveTarget}
                    onCancel={onCancel}
                    filterText={this.state.filterText}
                    onFilterTextChange={this._onFilterTextChange}
                />
                <CardList
                    status={status}
                    cards={this._getFilteredCards()}
                    toggles={[cardType]}
                    onClick={onClick}
                    filterText={this.state.filterText}
                    itemtypes={[CardItemType.Folder, CardItemType.Search]}
                />
            </>
        );
    }
}

export default ArchiveTargetCards;
